import React, { memo, Suspense, useMemo, useState } from 'react';
import { ConfigProvider } from 'antd';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import DataControl from '@/data-control';
import { PermissionCtx } from '@/store/context'
import Layout from "./components/layout/index";
import './utils/flexible'
import './App.css'
import zhCN from 'antd/es/locale/zh_CN';
import LoadingView from "@/components/loading-view";

export default memo(function App() {
    const loginInfo = DataControl.getCacheLoginInfo() || {}
    const [routerArr, setPermission] = useState(loginInfo.routerArr || [])
    const [optPermission, setOptPermission] = useState({
        productArr: loginInfo.productArr || [], system: loginInfo.system || []
    })
    const [isAdmin, setIsAdmin] = useState(loginInfo.isAdmin)
    const store = useMemo(() => {
        return {
            routerArr, updateRouterArr: setPermission,
            optPermission, updateOptArr: setOptPermission,
            isAdmin, setIsAdmin
        }
    }, [routerArr, setPermission, optPermission, setOptPermission, isAdmin, setIsAdmin])
    return (
        <ConfigProvider locale={zhCN}>
            <Provider store={DataControl.store}>
                <BrowserRouter>
                    <PermissionCtx.Provider value={store}>
                        <Layout />
                        <LoadingView />
                    </PermissionCtx.Provider>
                </BrowserRouter>
            </Provider>
        </ConfigProvider>
    )
})
